import { render, staticRenderFns } from "./Transcript.vue?vue&type=template&id=db47ebc0&scoped=true&"
import script from "./Transcript.vue?vue&type=script&lang=js&"
export * from "./Transcript.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db47ebc0",
  null
  
)

export default component.exports